import React, { Component } from "react";
import { connect } from "react-redux";
import { setAuth } from "actions";

export default (ChildComponent) => {
  class ComposedComponent extends Component {
    componentDidMount() {
      this.check();
    }

    componentDidUpdate() {
      this.check();
    }

    check = () => {
      if (!this.props.auth.token && localStorage.getItem("token")) {
        this.props.setAuth(
          localStorage.getItem("token"),
          localStorage.getItem("expires"),
          localStorage.getItem("refreshToken"),
          localStorage.getItem("refreshTokenExpiration")
        );
      }

      if (!localStorage.getItem("token")) {
        // TODO : add expiration logic
        this.props.history.push("/login");
      }
    };

    render() {
      return <ChildComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return { auth: state.auth };
  }
  return connect(mapStateToProps, { setAuth })(ComposedComponent);
};
